<!-- @format -->

<delivery-list-tag>
  <table class="contents_table">
    <tbody>
      <tr class="column_invoices-table">
        <th>
          <div class="sort-cel">
            納品番号
            <div
              if="{ props.orderBy }"
              class="{ getSortStateClass('id') }"
              onclick="{ e => props.setOrderBy(props.orderBy == 'asc' ? 'desc' : 'asc', 'id') }"
            ></div>
          </div>
        </th>
        <th>
          <div class="sort-cel">
            注文ID / 注文名
            <div
              class="button_sort"
              if="{ props.orderBy }"
              class="{ getSortStateClass('order_id') }"
              onclick="{ e => props.setOrderBy(props.orderBy == 'asc' ? 'desc' : 'asc', 'order_id') }"
            ></div>
          </div>
        </th>
        <th>説明</th>
        <th>数量</th>
        <th>単価</th>
        <th>金額（税込）</th>
        <th>納品日</th>
      </tr>
      <tr each="{ (delivery,i) in props.list }">
        <td>{ delivery.id }</td>
        <td>
          <a onclick="{ e => detail(e,delivery) }">
            {delivery.order_id } / { delivery.name }
          </a>
        </td>
        <td>{ delivery.description }</td>
        <td>{ Number(delivery.quantity) }</td>
        <td>{ Number(delivery.unit_price).toLocaleString()} 円</td>
        <td>{ Number(delivery.price).toLocaleString()} 円</td>
        <td>{ delivery.delivery_at }</td>
      </tr>
    </tbody>
  </table>

  <template if="{false}">
    <div if="{state.isLoading}" class="ui active inverted dimmer">
      <div class="ui text loader">Loading</div>
    </div>

    <template if="{state.deliverables.length > 0}">
      <div if="{!props.in_top}">全{state.pager.total}件中　x〜ｘ件</div>
      <table class="ui very compact table">
        <thead>
          <tr>
            <th if="{props.in_top}">納品番号</th>
            <th if="{!props.in_top}">
              納品番号&nbsp;
              <i
                class="icon sort amount {state.orderby}"
                onclick="{(e)=>toggleOrderby(e)}"
                style="cursor: pointer"
              ></i>
            </th>
            <th>注文ID/注文名</th>
            <th>説明</th>
            <th>数量</th>
            <th>単価</th>
            <th>金額（税抜）</th>
            <th>納品日</th>
          </tr>
        </thead>
        <tbody>
          <tr each="{ (delivery,i) in state.deliverables }">
            <td>{delivery.id}</td>
            <td>
              <a onclick="{(e)=>detail(e,delivery)}">
                {delivery.order_id} / {delivery.name}
                <i class="icon external alternate"></i>
              </a>
            </td>
            <td>{delivery.description}</td>
            <td>{Number(delivery.quantity)}</td>

            <td>{Number(delivery.unit_price).toLocaleString()}円</td>
            <td>{Number(delivery.price).toLocaleString()}円</td>
            <td>{delivery.delivery_at}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <div if="{state.deliverables.length == 0}">納品はありません</div>

    <div
      class="ui segment center aligned basic"
      is="pagination-tag"
      pager="{state.pager}"
      onpager="{(e,page)=>props.updatePage(page)}"
      if="{state.deliverables.length > 0 && !props.in_top}"
    ></div>
  </template>

  <script>
    export default {
      detail(e, delivery) {
        window.open(delivery.detail_link, `delivery-${delivery.id}`);
      },
      getSortStateClass(name) {
        if (name == this.props.orderName) {
          return this.props.orderBy == "asc"
            ? "button_sort-ascend"
            : "button_sort-descend";
        } else {
          return "button_sort";
        }
      },
    };
  </script>
</delivery-list-tag>
